import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import { Input } from "@/components/ui/input";
import { SearchIcon, XIcon } from "lucide-react";
import { updateSearchParams } from "@/lib/utils";
import { useRouter } from "@bprogress/next";
import { trans } from "@/service/i18n/i18n";

export function TextFilter({
  filter,
  onChange,
}: {
  filter: Filter;
  onChange?: any;
  theme?: string;
}) {
  const { name, placeholder, value } = filter;
  const [currentValue, setCurrentValue] = useState(value ?? null);
  const [debouncedValue] = useDebounce(currentValue, 500);
  const router = useRouter();
  useEffect(() => {
    setCurrentValue(filter.value ?? null);
  }, [filter.value]);

  useEffect(() => {
    if (onChange) {
      onChange(debouncedValue);
    }
    updateSearchParams(
      name,
      debouncedValue && String(debouncedValue).length > 0
        ? String(debouncedValue)
        : null,
      router,
    );
  }, [debouncedValue]);

  return (
    <div
      className={
        "relative flex items-center gap-2 rounded-lg border-[1px] border-[#B2BAC5] px-4 py-2"
      }
    >
      <SearchIcon size={"16px"} />
      <Input
        className={"h-5 rounded-none border-none p-0 ring-0! shadow-none!"}
        name={name}
        id={name}
        type={"text"}
        placeholder={trans(placeholder)}
        onChange={(event) => {
          setCurrentValue(event.target?.value);
        }}
        value={String(currentValue ?? "")}
        autoComplete="off"
      />

      {String(currentValue ?? "").length > 0 && (
        <div
          onClick={() => {
            setCurrentValue(null);
          }}
          className={"absolute top-0 right-0 p-2 hover:cursor-pointer"}
        >
          <XIcon size={16} color={"#abb1c2"} />
        </div>
      )}
    </div>
  );
}
